var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuNotifications = function SvgMenuNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.026.975C8.347.975 5.5 4.199 5.957 7.849l.086.688a3.14 3.14 0 0 1-.987 2.7A4.77 4.77 0 0 0 4 16.82l.112.23a5.11 5.11 0 0 0 4.6 2.882h8.906a4.942 4.942 0 0 0 3.363-8.563l-.047-.045a3.4 3.4 0 0 1-1.059-2.909l.07-.56c.457-3.654-2.392-6.881-6.074-6.881zM10.6 21.883a.812.812 0 1 0-1.3.975l.324.434c1.788 2.383 5.363 2.383 7.15 0l.325-.434a.812.812 0 1 0-1.3-.975l-.325.434a2.844 2.844 0 0 1-4.55 0z"
  })));
};
export { SvgMenuNotifications as ReactComponent };